import { resizeScroll } from '../core/ScrollService.js';
import { initGfFormTracking } from './gfFormTracking.js';

let gravityFormsScrollSyncBound = false;

/**
 * Après rendu ou confirmation GF, la hauteur de page change :
 * on recalcule Locomotive pour éviter un scroll « cassé ».
 */
const initGravityFormsScrollSync = () => {
    if (gravityFormsScrollSyncBound || typeof jQuery === 'undefined') {
        return;
    }
    gravityFormsScrollSyncBound = true;
    jQuery(document).on('gform_confirmation_loaded.gformScrollUpdate', () => resizeScroll());
    jQuery(document).on('gform_post_render.gformScrollUpdate', () => resizeScroll());
    initGfFormTracking();
};

const runLandingAttributionBridge = () => {
    if (!window.gfUtmTracker) return;
    if (typeof window.gfUtmTracker.capture === 'function') {
        window.gfUtmTracker.capture();
    }
    if (typeof window.gfUtmTracker.apply === 'function') {
        window.gfUtmTracker.apply();
    }
};

export { initGravityFormsScrollSync, runLandingAttributionBridge };
